module.exports = {
  formData: {
    modelName: '',
    type : '',
    media: '',
    channel: '',
    age: "769",
    minAge:7,
    maxAge:69,
    gender:'MF',
    genderLabel:'MF769',
    targetCode: 'MF769',
    demographic_cnt: 0,
    targetOnOff: true,
  },
  ScreenMediaStructure : {
    "VA":{
      "TV": {
      },
      "PC": {
      },
      "Mobile": {
      },
      "Digital": {
      },
    },
    "DA":{
      "Digital": {
      },
      "PC": {
      },
      "Mobile": {
      },
    }
  },
  ScreenMediaStructure_B : {
    "VA":{
      "TV": {
      },
      "PC": {
      },
      "Mobile": {
      },
      "Digital": {
      },
    },
    "DA":{
      // "Digital": {
      // },
      "PC": {
      },
      "Mobile": {
      },
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/common/ModelFormData.js